// extracted by mini-css-extract-plugin
export default {"container":"Overlay_container__qR8Cj"};